import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}
// export function login(username, password) {
//   return request({
//     url: '/admin/login',
//     method: 'get',
//     params: {
//       username,
//       password
//     }
//   })
// }

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(data) {
  return request({
    url: '/admin/list',
    method: 'post',
    data
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateMyself(id, data) {
  return request({
    url: '/admin/updateMyself',
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}

//获取数据权限list
export function dataPermissionList(data) {
  return request({
    // baseURL: "http://srtestadmin.weiputech.com",
    url: '/dictionary/findByType',
    method: 'post',
    data: data
  })
}

//根据parentId获取对应的部门信息
export function orgInfoList(data) {
  return request({
    url: '/organization/findByParentParam',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js